import type { ComponentPropsWithoutRef } from 'react'

const ButtonGroup = ({ className = '', ...props }: ComponentPropsWithoutRef<'div'>) => (
  <div className={`mt-2.5 flex gap-x-2.5 ${className}`} {...props} />
)

export default ButtonGroup
